
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46all_93AnuLOEFWmMMeta } from "/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/[...all].vue?macro=true";
import { default as addressRvdr7PnKEvMeta } from "/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/account/address.vue?macro=true";
import { default as indexJG95hwBSssMeta } from "/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/account/index.vue?macro=true";
import { default as order97QlTww4ZGMeta } from "/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/account/order.vue?macro=true";
import { default as paymentyvNdhEKTqWMeta } from "/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/account/payment.vue?macro=true";
import { default as profilezk89XArQ3yMeta } from "/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/account/profile.vue?macro=true";
import { default as indexIwgPyXVYOLMeta } from "/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/account/recover/index.vue?macro=true";
import { default as password9bIZNO9sR8Meta } from "/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/account/recover/password.vue?macro=true";
import { default as cartiXoOBWVALOMeta } from "/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/checkout/cart.vue?macro=true";
import { default as indexK6K63JnDpgMeta } from "/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/checkout/index.vue?macro=true";
import { default as index9inlcDnaVQMeta } from "/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/checkout/success/[id]/index.vue?macro=true";
import { default as paidK8Vq6iOWy0Meta } from "/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/checkout/success/[id]/paid.vue?macro=true";
import { default as unpaidKvTzc3QRW2Meta } from "/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/checkout/success/[id]/unpaid.vue?macro=true";
import { default as login4vqni90t6oMeta } from "/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/login.vue?macro=true";
import { default as newsletter_45subscribe9VOVuUtwQnMeta } from "/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/newsletter-subscribe.vue?macro=true";
import { default as registerUe2h3XwEtbMeta } from "/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/register.vue?macro=true";
import { default as reset_45passwordhGqymiy30eMeta } from "/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/reset-password.vue?macro=true";
import { default as searchiQqsOJSmMMMeta } from "/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/search.vue?macro=true";
import { default as shopwareQSd9MPfABrMeta } from "/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/shopware.vue?macro=true";
import { default as wishlistRjoK4QDGzRMeta } from "/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/wishlist.vue?macro=true";
import { default as component_45stubVv0d4wj2J2Meta } from "/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubVv0d4wj2J2 } from "/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "all___fr-CH",
    path: "/fr-CH/:all(.*)*",
    component: () => import("/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/[...all].vue")
  },
  {
    name: "all___de-DE",
    path: "/:all(.*)*",
    component: () => import("/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/[...all].vue")
  },
  {
    name: "account-address___fr-CH",
    path: "/fr-CH/account/address",
    meta: addressRvdr7PnKEvMeta || {},
    component: () => import("/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/account/address.vue")
  },
  {
    name: "account-address___de-DE",
    path: "/account/address",
    meta: addressRvdr7PnKEvMeta || {},
    component: () => import("/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/account/address.vue")
  },
  {
    name: "account___fr-CH",
    path: "/fr-CH/account",
    meta: indexJG95hwBSssMeta || {},
    component: () => import("/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/account/index.vue")
  },
  {
    name: "account___de-DE",
    path: "/account",
    meta: indexJG95hwBSssMeta || {},
    component: () => import("/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/account/index.vue")
  },
  {
    name: "account-order___fr-CH",
    path: "/fr-CH/account/order",
    meta: order97QlTww4ZGMeta || {},
    component: () => import("/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/account/order.vue")
  },
  {
    name: "account-order___de-DE",
    path: "/account/order",
    meta: order97QlTww4ZGMeta || {},
    component: () => import("/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/account/order.vue")
  },
  {
    name: "account-payment___fr-CH",
    path: "/fr-CH/account/payment",
    meta: paymentyvNdhEKTqWMeta || {},
    component: () => import("/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/account/payment.vue")
  },
  {
    name: "account-payment___de-DE",
    path: "/account/payment",
    meta: paymentyvNdhEKTqWMeta || {},
    component: () => import("/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/account/payment.vue")
  },
  {
    name: "account-profile___fr-CH",
    path: "/fr-CH/account/profile",
    meta: profilezk89XArQ3yMeta || {},
    component: () => import("/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/account/profile.vue")
  },
  {
    name: "account-profile___de-DE",
    path: "/account/profile",
    meta: profilezk89XArQ3yMeta || {},
    component: () => import("/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/account/profile.vue")
  },
  {
    name: "account-recover___fr-CH",
    path: "/fr-CH/account/recover",
    component: () => import("/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/account/recover/index.vue")
  },
  {
    name: "account-recover___de-DE",
    path: "/account/recover",
    component: () => import("/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/account/recover/index.vue")
  },
  {
    name: "account-recover-password___fr-CH",
    path: "/fr-CH/account/recover/password",
    component: () => import("/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/account/recover/password.vue")
  },
  {
    name: "account-recover-password___de-DE",
    path: "/account/recover/password",
    component: () => import("/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/account/recover/password.vue")
  },
  {
    name: "checkout-cart___fr-CH",
    path: "/fr-CH/checkout/cart",
    component: () => import("/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/checkout/cart.vue")
  },
  {
    name: "checkout-cart___de-DE",
    path: "/checkout/cart",
    component: () => import("/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/checkout/cart.vue")
  },
  {
    name: "checkout___fr-CH",
    path: "/fr-CH/checkout",
    meta: indexK6K63JnDpgMeta || {},
    component: () => import("/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/checkout/index.vue")
  },
  {
    name: "checkout___de-DE",
    path: "/checkout",
    meta: indexK6K63JnDpgMeta || {},
    component: () => import("/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/checkout/index.vue")
  },
  {
    name: "checkout-success-id___fr-CH",
    path: "/fr-CH/checkout/success/:id()",
    component: () => import("/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/checkout/success/[id]/index.vue")
  },
  {
    name: "checkout-success-id___de-DE",
    path: "/checkout/success/:id()",
    component: () => import("/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/checkout/success/[id]/index.vue")
  },
  {
    name: "checkout-success-id-paid___fr-CH",
    path: "/fr-CH/checkout/success/:id()/paid",
    component: () => import("/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/checkout/success/[id]/paid.vue")
  },
  {
    name: "checkout-success-id-paid___de-DE",
    path: "/checkout/success/:id()/paid",
    component: () => import("/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/checkout/success/[id]/paid.vue")
  },
  {
    name: "checkout-success-id-unpaid___fr-CH",
    path: "/fr-CH/checkout/success/:id()/unpaid",
    component: () => import("/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/checkout/success/[id]/unpaid.vue")
  },
  {
    name: "checkout-success-id-unpaid___de-DE",
    path: "/checkout/success/:id()/unpaid",
    component: () => import("/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/checkout/success/[id]/unpaid.vue")
  },
  {
    name: "login___fr-CH",
    path: "/fr-CH/login",
    component: () => import("/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/login.vue")
  },
  {
    name: "login___de-DE",
    path: "/login",
    component: () => import("/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/login.vue")
  },
  {
    name: "newsletter-subscribe___fr-CH",
    path: "/fr-CH/newsletter-subscribe",
    component: () => import("/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/newsletter-subscribe.vue")
  },
  {
    name: "newsletter-subscribe___de-DE",
    path: "/newsletter-subscribe",
    component: () => import("/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/newsletter-subscribe.vue")
  },
  {
    name: "register___fr-CH",
    path: "/fr-CH/register",
    component: () => import("/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/register.vue")
  },
  {
    name: "register___de-DE",
    path: "/register",
    component: () => import("/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/register.vue")
  },
  {
    name: "reset-password___fr-CH",
    path: "/fr-CH/reset-password",
    component: () => import("/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/reset-password.vue")
  },
  {
    name: "reset-password___de-DE",
    path: "/reset-password",
    component: () => import("/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/reset-password.vue")
  },
  {
    name: "search___fr-CH",
    path: "/fr-CH/search",
    component: () => import("/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/search.vue")
  },
  {
    name: "search___de-DE",
    path: "/search",
    component: () => import("/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/search.vue")
  },
  {
    name: "shopware___fr-CH",
    path: "/fr-CH/shopware",
    component: () => import("/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/shopware.vue")
  },
  {
    name: "shopware___de-DE",
    path: "/shopware",
    component: () => import("/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/shopware.vue")
  },
  {
    name: "wishlist___fr-CH",
    path: "/fr-CH/wishlist",
    component: () => import("/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/wishlist.vue")
  },
  {
    name: "wishlist___de-DE",
    path: "/wishlist",
    component: () => import("/home/bio-circle-nuxt/bio-circle-nuxt.on-forge.com/releases/75793960/pages/wishlist.vue")
  },
  {
    name: component_45stubVv0d4wj2J2Meta?.name,
    path: "/.well-known/appspecific/:pathMatch(.*)",
    component: component_45stubVv0d4wj2J2
  }
]